import React, { useEffect, useState } from 'react';
import Button from './Button';

const STORAGE_KEY = 'appex-cookie-consent';

function CookieConsent() {
	const [visible, setVisible] = useState(false);
	useEffect(() => {
		const stored = localStorage.getItem(STORAGE_KEY);
		if (!stored) setVisible(true);
	}, []);
	if (!visible) return null;
	return (
		<div className="container" style={{ position: 'fixed', bottom: 14, left: 0, right: 0, zIndex: 20 }}>
			<div className="card" style={{ padding: 14, display: 'flex', gap: 12, alignItems: 'center', justifyContent: 'space-between' }}>
				<p className="helper" style={{ margin: 0 }}>
					We use cookies for essential site functionality and to improve your experience. See our Privacy Policy for details.
				</p>
				<Button onClick={() => { localStorage.setItem(STORAGE_KEY, '1'); setVisible(false); }}>OK</Button>
			</div>
		</div>
	);
}

export default CookieConsent;


